// extracted by mini-css-extract-plugin
module.exports = {"link":"_ab87d85","linkText":"_ba36335","sgm":"_efc0808"};